import { useEffect, useState } from "react";

export default function useBreakPoint() {
  const [width, setWidth] = useState(window.innerWidth);
  const updateWidth = (ev: Event) => {
    const target = ev.target as Window;
    setWidth(target.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, []);
  if (width <= 768) {
    return "phone";
  }
  if (width < 1024) {
    return "tablet";
  }
  return "desktop";
}
